import { createAsyncThunk } from '@reduxjs/toolkit';

import { del, get, put, post } from './http';
import { activeSnack } from '../store/common';

export const createState = createAsyncThunk(
  'state/create',
  async ({ state, dispatch, handleClose, handleClear }) => {
    try {
      const URL = `/state/admin/new`;
      const response = await post(URL, state);
      if (response) {
        handleClose();
        handleClear();
        dispatch(
          getAllState({
            page: 1,
            search: '',
            dispatch,
            limit: sessionStorage.getItem('rowsPerPage_state'),
            country: '',
          })
        );
        dispatch(activeSnack({ type: 'success', message: 'State created successfully' }));
        return response;
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);

export const getAllState = createAsyncThunk(
  'state/list',
  async ({ page, search, dispatch, limit, country }) => {
    try {
      const response = await get(
        `/state/all?page=${page && page}&search=${search && search}&limit=${limit || 5}&country=${
          country || ''
        }`
      );
      // console.log(response);
      if (response) {
        return response;
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);

export const getStateDetails = createAsyncThunk('state/single', async ({ stateId, dispatch }) => {
  try {
    // console.log('ID:', stateId);
    const response = await get(`/state/admin/${stateId}`);
    if (response) {
      return response;
    }
    return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
  } catch (error) {
    dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
    throw error?.response?.data?.message;
  }
});

export const updateStateDetails = createAsyncThunk(
  'state/update',
  async ({ state, stateId, dispatch, handleClose, handleClear }) => {
    try {
      const URL = `/state/admin/${stateId}`;

      const response = await put(URL, state);
      if (response) {
        if (handleClose) {
          handleClose();
        }
        if (handleClear) {
          handleClear();
        }
        dispatch(
          getAllState({
            page: 1,
            search: '',
            dispatch,
            limit: sessionStorage.getItem('rowsPerPage_state'),
            country: '',
          })
        );
        dispatch(activeSnack({ type: 'success', message: 'State updated Successfully' }));
        return response;
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);

export const deleteState = createAsyncThunk('state/delete', async ({ stateId, dispatch }) => {
  try {
    const response = await del(`/state/admin/${stateId}`);
    if (response) {
      dispatch(activeSnack({ type: 'success', message: 'State deleted Successfully' }));
      return response?._id;
    }
    return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
  } catch (error) {
    dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
    throw error?.response?.data?.message;
  }
});
